import { Directive } from '@angular/core';
import * as i0 from "@angular/core";
export class RenderEmptyDirective {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RenderEmptyDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: RenderEmptyDirective, selector: "[renderEmpty]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RenderEmptyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[renderEmpty]',
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });
